import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ProjectSettingsBranchRestrictionsLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./branch-restrictions'),
});
